import React, { useState, useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FiX, FiCheck } from 'react-icons/fi';
import { FaBuilding } from 'react-icons/fa';
import axios from 'axios';
import { POST_MASTER_DATA, BASE_URL, PUT_MASTER_DATA } from '../utlilities/config';


const Spinner = () => (
  <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm">
    <div className="flex flex-col items-center gap-3">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
      <p className="text-indigo-600 font-medium">Processing...</p>
    </div>
  </div>
);

const AddDepartmentModal = ({ setShowModal, onSave, departmentId, departmentName, setDepartmentName, setSelectedDepartmentId }) => {

  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('accessToken');

  // Create refs for keyboard navigation
  const departmentNameRef = useRef(null);
  const saveButtonRef = useRef(null);

  useEffect(() => {
    // Focus on first field after modal opens
    setTimeout(() => {
      departmentNameRef.current && departmentNameRef.current.focus();
    }, 100);
  }, []);

  const handleCancel = () => {
    setSelectedDepartmentId(null);
    setDepartmentName('');
    setShowModal(false);
  };

  // Handle keyboard navigation between fields
  const handleKeyDown = (e, nextFieldRef, fallbackRef = null) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextFieldRef?.current) {
        nextFieldRef.current.focus();
      } else if (fallbackRef?.current) {
        fallbackRef.current.focus();
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      department_name: departmentName || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      department_name: Yup.string().required('Department Name is required'),
    }),

    onSubmit: async (values) => {
      try {
        console.log('hreeeee',values);
        setLoading(true);

        if(departmentId){
          console.log('hereee insideee 1');
          const response = await axios.post(`${BASE_URL}${PUT_MASTER_DATA}`, {}, {
            headers: {
              'XApiKey': process.env.REACT_APP_API_KEY,
              'Authorization': `Bearer ${token}`,
              'Name': values.department_name,
              'ID': departmentId,
            },
          });

          if(response.status === 200){
            handleCancel();
            onSave();
          }

        }else{
          const response = await axios.post(`${BASE_URL}${POST_MASTER_DATA}`, {}, {
            headers: {
              'XApiKey': process.env.REACT_APP_API_KEY,
              'Authorization': `Bearer ${token}`,
              'Name': values.department_name,
              'Type': 'D'
            },
          });

          if(response.status === 200){
            console.log('hereee insideee 2');
            setLoading(false);
            setShowModal(false);
            onSave();
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      {loading && <Spinner />}
      
      <div className="bg-white w-3/5 max-w-xl rounded-2xl shadow-2xl transform transition-transform duration-300 ease-out animate-zoom-in overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-8 py-5 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-white flex items-center">
            <FaBuilding className="mr-2" /> {departmentId ? 'Edit Department' : 'Add New Department'}
          </h2>
          <button 
            onClick={handleCancel}
            className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors duration-200"
            aria-label="Close modal"
          >
            <FiX size={20} />
          </button>
        </div>
        
        <form onSubmit={formik.handleSubmit} className="p-8">
          {/* Department Name Field */}
          <div className="w-full">
            <div className="flex justify-between mb-1.5">
              <label className="text-sm font-medium text-black-700 flex items-center">
                <FaBuilding className="mr-2" /> Department Name <span className="text-red-500 ml-1">*</span>
              </label>
            </div>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-indigo-400">
                <FaBuilding />
              </div>
              <input
                type="text"
                name="department_name"
                placeholder="Enter Department Name (e.g., Casualty, Lab, IP Pharmacy)"
                className={`w-full pl-10 pr-3 py-3 border ${
                  formik.touched.department_name && formik.errors.department_name ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : 'border-gray-200 focus:border-indigo-500 focus:ring-indigo-200'
                } bg-gray-50 rounded-lg focus:ring-2 focus:outline-none transition-colors duration-200`}
                value={formik.values.department_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                ref={departmentNameRef}
                onKeyDown={(e) => handleKeyDown(e, saveButtonRef)}
              />
            </div>
            {formik.touched.department_name && formik.errors.department_name && (
              <p className="mt-1 text-sm text-red-500">{formik.errors.department_name}</p>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-4 pt-6 mt-6 border-t border-gray-100">
            <button
              type="button"
              className="px-6 py-2.5 text-sm font-medium text-black-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:ring-4 focus:ring-gray-200 transition-colors duration-200 flex items-center"
              onClick={handleCancel}
            >
              <FiX className="mr-2" /> Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg hover:from-indigo-700 hover:to-purple-700 focus:ring-4 focus:ring-indigo-300 transition-all duration-200 shadow-md hover:shadow-lg flex items-center"
              ref={saveButtonRef}
            >
              <FiCheck className="mr-2" /> {departmentId ? 'Update Department' : 'Save Department'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDepartmentModal;

